export default __webpack_public_path__ + "static/media/svg-6.9ccb6bc7.svg";